module.exports = __webpack_public_path__ + "static/media/2.97e850e6.jpg";